<template>
  <div>
    <b-modal
      ref="modal"
      title="Lançamento de estoque"
      header-class="border-bottom-0"
      footer-class=" border-top-0"
      size="lg"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <select-input
              v-model="form.type.value"
              :alias="form.type.alias"
              :options="form.type.options"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <search-input
              :alias="'Produto'"
              v-model="form.product_base_id.value"
              :displayedValue="form.product.value"
              :form="form"
              :name="'product_base_id'"
              @search="searchProduct($event)"
              :searchResult="searchProductResults"
              :ref="'searchProductInput'"
              @selected="setProductValue($event)"
            >
              <search-input-option
                v-for="(row, index) in searchProductResults.data"
                tabindex="0"
                :key="index"
                :index="index"
                @click="setProductValue(row)"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <small class="text-muted">{{ row.base_sku_id }}</small>
                    - {{ row.description }}
                    <br />
                    <small class="text-muted">{{row.brand}} &nbsp;</small>
                  </div>
                  <div class="text-right">
                    <template v-if="enabledPolicePrice">
                      à vista {{ row.price_payment_immediate | decimal }}
                      <br />
                      à prazo {{ row.price_payment_on_terms | decimal }}
                    </template>
                    <template v-else>{{ row.price | decimal }}</template>
                    <template v-if="disableEstoque">
                      <p>
                        <small class="text-muted">Estoque {{row.stock | decimal}}</small>
                      </p>
                    </template>
                  </div>
                </div>
              </search-input-option>
            </search-input>
          </div>
          <div class="col-md-4">
            <number-input v-model="form.quantity.value" :alias="'Quantidade'"  :decimalPlaces="3"/>
          </div>
        </div>

        <template v-if="form.type.value == 'i'">
          <div class="row">
            <div class="col-md-4">
              <number-input :alias="'Preço de custo'" v-model="form.cost.value" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <small class="text-info">
                <i class="fas fa-lightbulb" /> Caso seja informado um preço de custo, o cadastro do produto será atualizado.
              </small>
            </div>
          </div>
        </template>
      </div>

      <br />

      <error-handler :error="error" />

      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
      >{{ alertData.message }}</b-alert>

      <!-- form  -->

      <div class="container-fluid d-flex justify-content-between" slot="modal-footer">
        <div>
          <b-checkbox
            tabindex="-1"
            switch
            v-model="enablesequential.value"
            :value="1"
          >Adicionar em sequência</b-checkbox>
        </div>
        <div>
          <button
            role="button"
            class="btn btn-outline-secondary"
            @click="$refs.modal.hide()"
            tabindex="-1"
          >
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button role="button" class="btn btn-success ml-2" style="margin-left:5px" @click="store">
            <i class="fas fa-check"></i> Salvar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";
//import moment from "moment";

export default {
  components: {},

  data: function() {
    return {
      form: new Form({
        // operation ??
        product_base_id: {},

        product: {},

        product_company_id: {},

        type: {
          alias: "Tipo de Movimentação",
          validate: {
            required: true
          },
          options: {
            "": "",
            i: "Entrada",
            o: "Saída"
          }
        },

        quantity: {},

        cost: {},

        price: {}
      }),

      enablesequential: {
        value: 0
      },

      searchProductResults: {},

      error: null,

      alertData: {
        isVisible: false,
        message: null
      }
    };
  },

  computed: {
    enabledPolicePrice() {
      if (this.$store.state.company.product_payment_policy == 2) {
        return true;
      }
    },

    disableEstoque() {
      return this.$store.state.company.module_stock_active == 1;
    },
  },

  methods: {
    open() {
      this.resetForm();

      this.$refs.modal.show();
    },

    searchProduct(text) {
      axios
        .post(process.env.BASE_URL + "api/searchproductorder/select", {
          description: text.text
        })
        .then(response => {
          this.searchProductResults = response.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    setProductValue(product) {
      this.form.product_base_id.value = product.id;
      this.form.product.value = product.description;
      //this.form.table_price.value      = product.price
      //this.form.price.value            = product.price
    },

    resetForm() {
      this.error = null;
      this.alertData.isVisible = false;
      this.form.reset();
    },

    addictionsequential() {
      if (this.enablesequential.value == 1) {
        this.form.quantity.value = "";

        this.form.cost.value = "";

        this.form.product.value = "";

        this.focusInput();
      } else {
        this.$refs.modal.hide();
      }
    },

    focusInput() {
      this.$refs.searchProductInput.setFocus();
    },

    store() {
       if (this.form.isValid()) {

       this.$store.commit("showLoading");
      axios
        .post("api/stock/store", this.form.getValues())
        .then(response => {
          this.addictionsequential();

          this.$emit("stored");

          // this.$store.commit("showAlert", {
          //   message: "Lançamento efetuado!",
          //   type: "success"
          //});

          return;
        })
        .catch(error => {
          this.error = error;

          this.$store.commit("hideLoading");

          return;
        });
      }
      else
      {
        this.form.isValid()

        this.alertData.message = this.form.getFirstErrorMsg()

        this.alertData.isVisible = true
      }
    }
  }
};
</script>
